import { create } from 'zustand'
import client from '../api/client'

const useBetStore = create((set, get) => ({
  credits: 0,
  transactions: [],
  recharges: [],
  withdrawals: [],
  adminWithdrawals: [],
  pools: {},
  isLoading: false,
  error: null,
  rechargeModalOpen: false,

  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error }),
  setRechargeModalOpen: (open) => set({ rechargeModalOpen: open }),

  // Obtener saldo e historial de transacciones del perfil
  fetchBalance: async () => {
    set({ isLoading: true, error: null })
    try {
      const response = await client.get('/profile/transactions')
      const data = response.data?.datos
      set({
        credits: Number(data?.saldo || 0),
        transactions: data?.transacciones || [],
        isLoading: false
      })
      return data
    } catch (err) {
      set({
        error: err.response?.data?.mensaje || err.message,
        isLoading: false
      })
      throw err
    }
  },

  // Obtener resumen del pozo de un partido específico
  fetchMatchPool: async (partidoId) => {
    try {
      const response = await client.get(`/bets/match/${partidoId}`)
      const data = response.data?.datos
      set((state) => ({
        pools: {
          ...state.pools,
          [partidoId]: data
        }
      }))
      return data
    } catch (err) {
      console.error('Error fetching match pool:', err)
      throw err
    }
  },

  // Realizar una apuesta en un partido
  placeBet: async (betData) => {
    set({ isLoading: true, error: null })
    try {
      const response = await client.post('/bets', betData)
      const data = response.data?.datos
      
      // Actualizar el pozo en el estado local y el saldo de créditos
      set((state) => ({
        credits: Number(data?.saldo_actual || 0),
        pools: {
          ...state.pools,
          [betData.partido_id]: {
            ...state.pools[betData.partido_id],
            pozo: data?.pozo,
            apuesta_usuario: {
              partido_id: betData.partido_id,
              seleccion: betData.seleccion,
              goles_predichos: betData.goles_predichos,
              monto: betData.monto,
              estado: 'pendiente'
            }
          }
        },
        isLoading: false
      }))
      return response.data
    } catch (err) {
      const msg = err.response?.data?.mensaje || err.message
      set({ error: msg, isLoading: false })
      throw err
    }
  },

  // Solicitar recarga de créditos
  requestRecharge: async (monto, referencia, voucherFile = null) => {
    set({ isLoading: true, error: null })
    try {
      const formData = new FormData()
      formData.append('monto', monto)
      formData.append('referencia', referencia)
      if (voucherFile) {
        formData.append('voucher', voucherFile)
      }
      const response = await client.post('/recharges', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      set({ isLoading: false })
      return response.data
    } catch (err) {
      const msg = err.response?.data?.mensaje || err.message
      set({ error: msg, bg: null, isLoading: false })
      throw err
    }
  },

  // Obtener solicitudes del usuario
  fetchUserRecharges: async () => {
    set({ isLoading: true, error: null })
    try {
      const response = await client.get('/recharges')
      set({
        recharges: response.data?.datos || [],
        isLoading: false
      })
      return response.data?.datos
    } catch (err) {
      set({
        error: err.response?.data?.mensaje || err.message,
        isLoading: false
      })
      throw err
    }
  },

  // Obtener solicitudes de retiro del usuario
  fetchUserWithdrawals: async () => {
    set({ isLoading: true, error: null })
    try {
      const response = await client.get('/withdrawals')
      set({
        withdrawals: response.data?.datos || [],
        isLoading: false
      })
      return response.data?.datos
    } catch (err) {
      set({
        error: err.response?.data?.mensaje || err.message,
        isLoading: false
      })
      throw err
    }
  },

  // Solicitar un retiro (FormData por la carga de archivo QR)
  requestWithdrawal: async (monto, qrFile = null, guardarQr = false) => {
    set({ isLoading: true, error: null })
    try {
      const formData = new FormData()
      formData.append('monto', monto)
      if (qrFile) {
        formData.append('qr_code', qrFile)
      }
      formData.append('guardar_qr', guardarQr ? '1' : '0')
      
      const response = await client.post('/withdrawals', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      
      // Actualizar el saldo actual si el backend lo retorna
      const saldoActual = response.data?.datos?.saldo_actual
      if (saldoActual !== undefined) {
        set({ credits: Number(saldoActual) })
      }
      
      set({ isLoading: false })
      return response.data
    } catch (err) {
      const msg = err.response?.data?.mensaje || err.message
      set({ error: msg, isLoading: false })
      throw err
    }
  },

  // Obtener todas las solicitudes de retiro (vista Admin)
  fetchAdminWithdrawals: async () => {
    set({ isLoading: true, error: null })
    try {
      const response = await client.get('/admin/withdrawals')
      set({
        adminWithdrawals: response.data?.datos || [],
        isLoading: false
      })
      return response.data?.datos
    } catch (err) {
      set({
        error: err.response?.data?.mensaje || err.message,
        isLoading: false
      })
      throw err
    }
  },

  // Procesar solicitud de retiro (Aprobar/Rechazar - vista Admin)
  processWithdrawal: async (id, data) => {
    set({ isLoading: true, error: null })
    try {
      const response = await client.put(`/admin/withdrawals/${id}`, data)
      set({ isLoading: false })
      return response.data
    } catch (err) {
      const msg = err.response?.data?.mensaje || err.message
      set({ error: msg, isLoading: false })
      throw err
    }
  }
}))

export default useBetStore
